// 帳號管理
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Collapse } from 'react-bootstrap';
import { i18n, getLocale } from 'core/i18n';
import Dialog from 'components/dialog/index';
import InputField from 'components/inputField/index';
import Select from 'components/reactSelect/index';
import CheckBox from 'components/checkbox/index';
import Button from 'components/button/index';

import './edit.css';

import {
  getAgent,
  putAgent,
  updateAgentInfo,
  clearAgentInfo
} from './action';

import {
  postRole
} from '../mainModule/action';

class ManageEditIndex extends Component {
  constructor(props) {
    super(props);
    this.handleSelectDefault = this.handleSelectDefault.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

    this.state = {
      pwEditable: false,
      addressSameAsOrg: false,
      showLockedDialog: false
    };
  }

  async componentDidMount() {
    const self = this,
      { props } = self,
      {
        mainState,
        editAgentId,
        dispatch = () => { }
      } = props,
      {
        roleOptions
      } = mainState;
    
    if (!roleOptions) {
      await dispatch(postRole());
    }
    await dispatch(getAgent(editAgentId));
  }

  componentWillUnmount() {
    const self = this,
    { props } = self,
    { dispatch = () => { } } = props;
    
    dispatch(clearAgentInfo());
  }

  handleSelectDefault(options, value) {
		let defaultValue = null;

		if (options) {
			for (let i = 0; i < options.length; i++) {
				if (options[i].value === value) {
					defaultValue = options[i];
					break;
				}
			}
		}
		
		return defaultValue;
	}

  handleSelectChange(type, value) {
    const self = this,
			{
				props
			} = self,
			{
				state,
				dispatch = () => { }
			} = props,
			{
				agentInfo
			} = state;
    let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
    
    switch (type) {
      case 'mobilePhone_dialCode':
        newAgentInfo.mobilePhone.dialCode = value;
        break;
      case 'workPhone_dialCode':
        newAgentInfo.workPhone.dialCode = value;
        break;
      default:
        newAgentInfo[type] = value;
        break;
    }

    dispatch(updateAgentInfo(newAgentInfo));
  }

  handleInputChange(type, value) {
    const self = this,
			{
				props
			} = self,
			{
				state,
				dispatch = () => { }
			} = props,
			{
				agentInfo
			} = state;
    let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
    
    switch (type) {
      case 'mobilePhone_number':
        newAgentInfo.mobilePhone.number = value;
        break;
      case 'workPhone_number':
        newAgentInfo.workPhone.number = value;
        break;
      default:
        newAgentInfo[type] = value;
        break;
    }

    dispatch(updateAgentInfo(newAgentInfo));
  }

  render() {
    const self = this,
      {
        props,
        state: _state,
        handleSelectDefault = () => { },
        handleSelectChange = () => { },
        handleInputChange = () => { }
      } = self,
      {
        state,
        mainState,
        editAgentId,
        onClose = () => { },
        dispatch = () => { }
      } = props,
      {
        agentInfo,
        addressInfo,
        errors,
        showSuccessDialog
      } = state,
      {
        langOptions,
        currencyOptions,
        titleOptions,
        dialCodeOptions,
        countryCodeOptions,
        roleOptions,
        statusOptions
      } = mainState,
      {
        pwEditable,
        addressSameAsOrg,
        showLockedDialog
      } = _state;
    
    return (
      agentInfo ? (
        <div className='manage-edit-container'>
          {/* success dialog */}
          <Dialog
            dialogId='manage-edit-success-dialog'
            maxWidth='xs'
            zIndex={2000}
            open={!!showSuccessDialog}
            onClose={() => {
              // 初始化捲軸位置
              if (typeof window !== 'undefined') {
                window.scrollTo({ top: 0, left: 0 });
              }
              // 導回帳號管理列表
              onClose();
            }}
            title={i18n('success_heading')}
            actionsClassName='manage-edit-success-dialog-action'
            actions={[
              <Button
                size='large'
                className={'close-button'}
                onClick={() => {
                  // 初始化捲軸位置
                  if (typeof window !== 'undefined') {
                    window.scrollTo({ top: 0, left: 0 });
                  }
                  // 導回帳號管理列表
                  onClose();
                }}
              >
                {i18n('close')}
              </Button>
            ]}
          >
            <div className='manage-edit-success-dialog-body'>{i18n('success_message_update')}</div>
          </Dialog>
          {/* locked agent dialog */}
          <Dialog
            dialogId='manage-edit-locked-dialog'
            maxWidth='xs'
            zIndex={2000}
            open={!!showLockedDialog}
            onClose={() => {
              self.setState({ showLockedDialog: !showLockedDialog });
            }}
            title={i18n('warning')}
            actionsClassName='manage-edit-locked-dialog-action'
            actions={[
              <Button
                size='large'
                className={'close-button'}
                onClick={() => {
                  self.setState({ showLockedDialog: !showLockedDialog });
                }}
              >
                {i18n('cancel')}
              </Button>,
              <Button
                size='large'
                className={'primary-button'}
                onClick={() => {
                  self.setState({ showLockedDialog: !showLockedDialog });

                  // 封鎖or取消封鎖此人，已更改的資料需一併更新
                  let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
                
                  // 如果有勾選 "地址同註冊地址"，則帶入addressInfo
                  if (addressSameAsOrg && addressInfo) {
                    newAgentInfo.address1 = addressInfo.address1;
                    newAgentInfo.address2 = addressInfo.address2;
                    newAgentInfo.city = addressInfo.city;
                    newAgentInfo.addressState = addressInfo.addressState;
                    newAgentInfo.country = addressInfo.country;
                    newAgentInfo.postalCode = addressInfo.postalCode;
                  }

                  dispatch(updateAgentInfo(newAgentInfo));
                  dispatch(putAgent(editAgentId, newAgentInfo, true));
                }}
              >
                {i18n('confirm')}
              </Button>
            ]}
          >
            <div className='manage-edit-locked-dialog-body'>
              {agentInfo.lock ? i18n('unlocked_message') : i18n('locked_message')}
            </div>
          </Dialog>
          {/* 登入資訊 */}
          <div className='manage-edit-panel login'>
            <div className='manage-edit-panel-title'>
              <img alt='' src={require('assets/images/passenger.svg')} />
              <span>{i18n('login_info')}</span>
            </div>
            <div className='manage-edit-panel-content'>
              <div className='manage-edit-panel-row'>
                {/* 旅行社組織 */}
                <div className='manage-edit-panel-item'>
                  <div className='manage-edit-panel-label'>{i18n('login_info_org_code')}</div>
                  <InputField
                    disabled={true}
                    onBlurActEvent={(data) => {
                      handleInputChange('organizationCode', data);
                    }}
                    defaultValue={agentInfo.organizationCode || ''}
                    validateMessage={errors && errors.organizationCode ? i18n('error_organization_name') : null}
                  />
                </div>
                {/* 旅行社登入帳號 */}
                <div className='manage-edit-panel-item'>
                  <div className='manage-edit-panel-label'>{i18n('login_info_org_status')}</div>
                  <Select
                    id={'manage-edit-status'}
                    isSearchable={false}
                    placeholder={agentInfo.agentStatus}
                    defaultValue={handleSelectDefault(statusOptions, agentInfo.agentStatus)}
                    options={statusOptions}
                    onChangeEvent={(data) => {
                      handleSelectChange('agentStatus', data.value);
                    }}
                    errorText={errors && errors.agentStatus ? i18n('error_agent_status') : null}
                  />
                </div>
              </div>
              <div className='manage-edit-panel-row'>
                {/* Skyagent 登入帳號 */}
                <div className='manage-edit-panel-item'>
                  <div className='manage-edit-panel-label'>{i18n('login_info_agent_id')}</div>
                  <InputField
                    disabled={true}
                    onBlurActEvent={(data) => {
                      handleInputChange('agentName', data);
                    }}
                    defaultValue={agentInfo.agentName || ''}
                    validateMessage={errors && errors.agentName ? i18n('error_agent_name') : null}
                  />
                </div>
                {/* 帳號類型 */}
                <div className='manage-edit-panel-item'>
                  <div className='manage-edit-panel-label'>{i18n('login_info_agent_type')}</div>
                  <Select
                    id={'manage-edit-agent-type'}
                    isSearchable={false}
                    placeholder={agentInfo.agentType}
                    defaultValue={handleSelectDefault(roleOptions, agentInfo.agentType)}
                    options={roleOptions}
                    onChangeEvent={(data) => {
                      handleSelectChange('agentType', data.value);
                    }}
                    errorText={errors && errors.agentType ? i18n('error_agent_type') : null}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* 設定 */}
          <div className='manage-edit-panel setting'>
            <div className='manage-edit-panel-title'>
              <img alt='' src={require('assets/images/setting.svg')} />
              <span>{i18n('settings')}</span>
            </div>
            <div className='manage-edit-panel-content'>
              <div className='manage-edit-panel-row'>
                {/* 幣值 */}
                <div className='manage-edit-panel-item'>
                  <div className='manage-edit-panel-label'>{i18n('settings_currency')}</div>
                  <Select
                    id={'manage-edit-currency'}
                    isSearchable={false}
                    isDisabled={true}
                    placeholder={agentInfo.preferredCurrency}
                    defaultValue={handleSelectDefault(currencyOptions, agentInfo.preferredCurrency)}
                    options={currencyOptions}
                    onChangeEvent={(data) => {
                      handleSelectChange('preferredCurrency', data.value);
                    }}
                    errorText={errors && errors.preferredCurrency ? i18n('error_preferred_currency') : null}
                  />
                </div>
                {/* 語言 */}
                <div className='manage-edit-panel-item'>
                  <div className='manage-edit-panel-label'>{i18n('settings_language')}</div>
                  <Select
                    id={'manage-edit-language'}
                    isSearchable={false}
                    placeholder={i18n('placeholder')}
                    defaultValue={handleSelectDefault(langOptions, agentInfo.preferredLanguage)}
                    options={langOptions}
                    onChangeEvent={(data) => {
                      handleSelectChange('preferredLanguage', data.value);
                    }}
                    errorText={errors && errors.preferredLanguage ? i18n('error_preferred_language') : null}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* 聯絡人詳細資訊 */}
          <div className='manage-edit-panel contact'>
            <div className='manage-edit-panel-title'>
              <img alt='' src={require('assets/images/passenger.svg')} />
              <span>{i18n('contact')}</span>
            </div>
            <div className='manage-edit-panel-content'>
              <div className='manage-edit-panel-row'>
                <div className='manage-edit-panel-item width-fifty'>
                  {/* 稱謂 */}
                  <div>
                    <div className='manage-edit-panel-label'>{i18n('contact_title')}</div>
                    <Select
                      id={'manage-edit-title'}
                      isSearchable={false}
                      placeholder={i18n('placeholder')}
                      defaultValue={handleSelectDefault(titleOptions, agentInfo.title)}
                      options={titleOptions}
                      onChangeEvent={(data) => {
                        handleSelectChange('title', data.value);
                      }}
                      errorText={errors && errors.title ? i18n('error_title') : null}
                    />
                  </div>
                  {/* 名字 */}
                  <div>
                    <div className='manage-edit-panel-label'>{i18n('first_name')}</div>
                    <InputField
                      inputType={'name'}
                      onBlurActEvent={(data) => {
                        handleInputChange('firstName', data);
                      }}
                      defaultValue={agentInfo.firstName || ''}
                      validateMessage={errors && errors.firstName ? i18n('error_first_name') : null}
                    />
                  </div>
                </div>
                {/* 姓氏 */}
                <div className='manage-edit-panel-item'>
                  <div className='manage-edit-panel-label'>{i18n('last_name')}</div>
                  <InputField
                    inputType={'name'}
                    onBlurActEvent={(data) => {
                      handleInputChange('lastName', data);
                    }}
                    defaultValue={agentInfo.lastName || ''}
                    validateMessage={errors && errors.lastName ? i18n('error_last_name') : null}
                  />
                </div>
              </div>
              <div className='manage-edit-panel-row'>
                {/* 手機號碼 */}
                <div className='manage-edit-panel-item width-fifty'>
                  <div>
                    <div className='manage-edit-panel-label'>{i18n('contact_mobile_number')}</div>
                    <Select
                      id={'manage-edit-mobile-dial-code'}
                      placeholder={i18n('placeholder')}
                      defaultValue={handleSelectDefault(dialCodeOptions[getLocale()], agentInfo.mobilePhone.dialCode)}
                      options={dialCodeOptions[getLocale()]}
                      onChangeEvent={(data) => {
                        handleSelectChange('mobilePhone_dialCode', data.value);
                      }}
                      errorText={errors && errors.mobilePhone && errors.mobilePhone.dialCode ? i18n('error_mobile_code') : null}
                    />
                  </div>
                  <div>
                    <div className='manage-edit-panel-label'></div>
                    <InputField
                      inputType={'tel'}
                      onBlurActEvent={(data) => {
                        handleInputChange('mobilePhone_number', data);
                      }}
                      defaultValue={agentInfo.mobilePhone.number || ''}
                      validateMessage={errors && errors.mobilePhone && errors.mobilePhone.number ? i18n('error_mobile_number') : null}
                    />
                  </div>
                </div>
                {/* 公司電話 */}
                <div className='manage-edit-panel-item width-fifty'>
                  <div>
                    <div className='manage-edit-panel-label'>{i18n('contact_office_number')}</div>
                    <Select
                      id={'manage-edit-office-dial-code'}
                      placeholder={i18n('placeholder')}
                      defaultValue={handleSelectDefault(dialCodeOptions[getLocale()], agentInfo.workPhone.dialCode)}
                      options={dialCodeOptions[getLocale()]}
                      onChangeEvent={(data) => {
                        handleSelectChange('workPhone_dialCode', data.value);
                      }}
                      errorText={errors && errors.workPhone && errors.workPhone.dialCode ? i18n('error_office_code') : null}
                    />
                  </div>
                  <div>
                    <div className='manage-edit-panel-label'></div>
                    <InputField
                      inputType={'tel'}
                      onBlurActEvent={(data) => {
                        handleInputChange('workPhone_number', data);
                      }}
                      defaultValue={agentInfo.workPhone.number || ''}
                      validateMessage={errors && errors.workPhone && errors.workPhone.number ? i18n('error_office_number') : null}
                    />
                  </div>
                </div>
              </div>
              <div className='manage-edit-panel-row'>
                {/* 電子郵件 */}
                <div className='manage-edit-panel-item'>
                  <div className='manage-edit-panel-label'>{i18n('contact_email')}</div>
                  <InputField
                    inputType={'email'}
                    maxLength={'50'}
                    onBlurActEvent={(data) => {
                      handleInputChange('email', data);
                    }}
                    defaultValue={agentInfo.email || ''}
                    validateMessage={errors && errors.email ? i18n('error_email') : null}
                  />
                </div>
                {/* 確認電子郵件 */}
                <div className='manage-edit-panel-item'>
                  <div className='manage-edit-panel-label'>{i18n('contact_confirm_email')}</div>
                  <InputField
                    inputType={'email'}
                    maxLength={'50'}
                    onBlurActEvent={(data) => {
                      handleInputChange('confirmEmail', data);
                    }}
                    defaultValue={agentInfo.confirmEmail || ''}
                    validateMessage={errors && errors.confirmEmail ? i18n('error_confirm_email') : null}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* 地址 */}
          <div className='manage-edit-panel address'>
            <div className='manage-edit-panel-title address'>
              <div>
                <img alt='' src={require('assets/images/address.svg')} />
                <span>{i18n('address')}</span>
              </div>
              <CheckBox
                id={'same-as-org'}
                className={'same-as-org'}
                value={addressSameAsOrg}
                checked={addressSameAsOrg}
                text={i18n('same_as_org')}
                onClick={() => {
                  // 勾選 "地址同註冊地址"，檢查是否取過addressInfo
                  if (!addressSameAsOrg && !addressInfo) {
                    dispatch(getAgent());
                  }

                  // 取消勾選 "地址同註冊地址"，則清空地址資訊
                  if (addressSameAsOrg) {
                    let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
                
                    if (newAgentInfo.address1) newAgentInfo.address1 = null;
                    if (newAgentInfo.address2) newAgentInfo.address2 = null;
                    if (newAgentInfo.city) newAgentInfo.city = null;
                    if (newAgentInfo.addressState) newAgentInfo.addressState = 'OTH';
                    if (newAgentInfo.country) newAgentInfo.country = null;
                    if (newAgentInfo.postalCode) newAgentInfo.postalCode = null;

                    dispatch(updateAgentInfo(newAgentInfo));
                  }

                  self.setState({
                    addressSameAsOrg: !addressSameAsOrg
                  });
                }}
              />
            </div>
            <Collapse in={!addressSameAsOrg || !addressInfo}>
              <div className='manage-edit-panel-content'>
                <div className='manage-edit-panel-row'>
                  {/* 地址 1 */}
                  <div className='manage-edit-panel-item'>
                    <div className='manage-edit-panel-label'>{i18n('address_line_1')}</div>
                    <InputField
                      maxLength={'52'}
                      onBlurActEvent={(data) => {
                        handleInputChange('address1', data);
                      }}
                      defaultValue={agentInfo.address1 || ''}
                      validateMessage={errors && errors.address1 ? i18n('error_address_1') : null}
                    />
                  </div>
                  {/* 地址 2 */}
                  <div className='manage-edit-panel-item'>
                    <div className='manage-edit-panel-label'>{i18n('address_line_2')}</div>
                    <InputField
                      maxLength={'52'}
                      onBlurActEvent={(data) => {
                        handleInputChange('address2', data);
                      }}
                      defaultValue={agentInfo.address2 || ''}
                      // validateMessage={errors && errors.address2 ? i18n('error_address_2') : null}
                    />
                  </div>
                </div>
                <div className='manage-edit-panel-row'>
                  {/* 城鎮 */}
                  <div className='manage-edit-panel-item'>
                    <div className='manage-edit-panel-label'>{i18n('address_city')}</div>
                    <InputField
                      onBlurActEvent={(data) => {
                        handleInputChange('city', data);
                      }}
                      defaultValue={agentInfo.city || ''}
                      validateMessage={errors && errors.city ? i18n('error_city') : null}
                    />
                  </div>
                  {/* 國家 */}
                  <div className='manage-edit-panel-item'>
                    <div className='manage-edit-panel-label'>{i18n('address_country')}</div>
                    {
                      !addressSameAsOrg ? (
                        <Select
                          id={'manage-edit-country'}
                          placeholder={i18n('placeholder')}
                          defaultValue={handleSelectDefault(countryCodeOptions[getLocale()], agentInfo.country)}
                          options={countryCodeOptions[getLocale()]}
                          onChangeEvent={(data) => {
                            handleSelectChange('country', data.value);
                          }}
                          errorText={errors && errors.country ? i18n('error_country') : null}
                        />
                      ) : null
                    }
                  </div>
                </div>
                <div className='manage-edit-panel-row'>                  
                  {/* 郵遞區號 */}
                  <div className='manage-edit-panel-item'>
                    <div className='manage-edit-panel-label'>{i18n('address_postal_code')}</div>
                    <InputField
                      onBlurActEvent={(data) => {
                        handleInputChange('postalCode', data);
                      }}
                      defaultValue={agentInfo.postalCode || ''}
                      // validateMessage={errors && errors.postalCode ? i18n('error_postal_code') : null}
                    />
                  </div>
                  <div className='manage-edit-panel-item'></div>
                </div>
              </div>
            </Collapse>
          </div>
          {/* 密碼 */}
          <div className='manage-edit-panel'>
            <div className='manage-edit-panel-title mima'>
              <div>
                <img alt='' src={require('assets/images/password.svg')} />
                <span>{i18n('password')}</span>
              </div>
              <Button
                className={'primary-button change-mima-btn'}
                onClick={() => {
                  let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
                  
                  // 變更密碼，則新增key
                  if (!pwEditable) {
                    newAgentInfo.password = '';
                    newAgentInfo.confirmPassword = '';
                  } else { // 取消變更密碼，則刪除key
                    delete newAgentInfo.password;
                    delete newAgentInfo.confirmPassword;
                  }

                  dispatch(updateAgentInfo(newAgentInfo));

                  self.setState({
                    pwEditable: !pwEditable
                  });
                }}
              >
                {i18n('password_change_pw')}
              </Button>
            </div>
            <div className='manage-edit-panel-content'>
              <div className='manage-edit-panel-row'>
                {/* 新密碼 */}
                <div className='manage-edit-panel-item'>
                  <div className='manage-edit-panel-label'>{i18n('password_new_pw')}</div>
                  <InputField
                    type={'password'}
                    inputType={'password'}
                    disabled={!pwEditable}
                    maxLength={'16'}
                    value={!pwEditable ? '' : agentInfo.password}
                    onBlurActEvent={(data) => {
                      handleInputChange('password', data);
                    }}
                    validateMessage={pwEditable && errors && errors.password ? i18n('error_password') : null}
                  />
                </div>
                {/* 確認密碼 */}
                <div className='manage-edit-panel-item'>
                  <div className='manage-edit-panel-label'>{i18n('password_confirm_pw')}</div>
                  <InputField
                    type={'password'}
                    inputType={'password'}
                    disabled={!pwEditable}
                    maxLength={'16'}
                    value={!pwEditable ? '' : agentInfo.confirmPassword}
                    onBlurActEvent={(data) => {
                      handleInputChange('confirmPassword', data);
                    }}
                    validateMessage={pwEditable && errors && errors.confirmPassword ? i18n('error_confirm_password') : null}
                  />
                </div>
              </div>
              <div className='manage-edit-panel-instruction'>{`* ${i18n('password_instruction')}`}</div>
            </div>
          </div>
          {/* 封鎖此人 & 儲存 */}
          <div className='manage-edit-panel-button'>
            <Button
              className={'close-button'}
              onClick={() => {
                self.setState({ showLockedDialog: !showLockedDialog });
              }}
            >
              {agentInfo.lock ? i18n('unlocked_agent') : i18n('locked_agent')}
            </Button>
            <Button
              className={'primary-button'}
              onClick={() => {
                let newAgentInfo = JSON.parse(JSON.stringify(agentInfo));
                
                // 如果有勾選 "地址同註冊地址"，則帶入addressInfo
                if (addressSameAsOrg && addressInfo) {
                  newAgentInfo.address1 = addressInfo.address1;
                  newAgentInfo.address2 = addressInfo.address2;
                  newAgentInfo.city = addressInfo.city;
                  newAgentInfo.addressState = addressInfo.addressState;
                  newAgentInfo.country = addressInfo.country;
                  newAgentInfo.postalCode = addressInfo.postalCode;
                }

                dispatch(updateAgentInfo(newAgentInfo));
                dispatch(putAgent(editAgentId, newAgentInfo));
              }}
            >
              {i18n('save')}
            </Button>
          </div>
        </div>
      ) : null
    );
  }
}

let mapStateToProps = (state) => {
  return {
    state: state.manageReducer,
    mainState: state.mainReducer
  };
};

export default connect(mapStateToProps)(ManageEditIndex);